import { render, staticRenderFns } from "./uptime.vue?vue&type=template&id=da5dce8e&"
import script from "./uptime.vue?vue&type=script&lang=js&"
export * from "./uptime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports